module.exports = __webpack_public_path__ + "img/best_2.62d662d4.svg";